/*
 * @Author: 廿夕 xuanwei@cai-inc.com
 * @Date: 2023-02-27 15:12:17
 * @LastEditors: 廿夕
 * @LastEditTime: 2023-03-23 11:48:23
 * @Description: 
 */
import { request } from '@/utils/request';

const urls = {
  list: '/api/zlbuser/exception/record/paging/exceptionRecord', // 异常数据列表接口
  handleExceptions: '/api/zlbuser/exception/record/deal/exceptionRecord', // 处理异常数据接口
  exceptionsStatusType: '/api/zlbuser/exception/record/type', // 事件类型和状态枚举：0状态，1事件类型
};

/**
 * 异常数据列表
 * @param {*} params 
 * @returns 
 */
export async function reqAbnormalUserList (params) {
  return request(urls.list, {
    method: 'POST',
    data: params,
  });
}

/**
 * 处理异常数据
 * @param {*} params 
 * @returns 
 */
export async function reqHandleExceptions (params) {
  return request(urls.handleExceptions, {
    method: 'POST',
    data: params,
  });
}

/**
 * 状态枚举下拉数据
 * @param {*} params 
 * @returns 
 */
export async function reqExceptionsStatusType (params) {
  return request(urls.exceptionsStatusType, { params });
}
